/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Link_Dialog_DescInputs */

const vi_kiotviet_link_dialog_desc = /** @type {(inputs: Kiotviet_Link_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn sản phẩm trong phần mềm ứng với dòng hàng KiotViet này. Các hoá đơn sau có cùng mã sẽ tự nối, các dòng chưa nối cùng mã ở đơn khác chưa xuất kho cũng được nối theo.`)
};

/**

* @param {Kiotviet_Link_Dialog_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_link_dialog_desc = /** @type {((inputs?: Kiotviet_Link_Dialog_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Link_Dialog_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_link_dialog_desc(inputs)
});